export default {
  OVER_ELEMENT: 'OVER_ELEMENT',
  INITIALIZE_PAINT: 'INITIALIZE_PAINT',
  INJECT_PAINT: 'INJECT_PAINT',
  CREATE_ROOT_ELEMENT: 'CREATE_ROOT_ELEMENT',
  CREATE_ELEMENT: 'CREATE_ELEMENT',
  ADD_TEMPLATE_TO_ROOT: 'ADD_TEMPLATE_TO_ROOT',
  ADD_TEMPLATE_TO_ELEMENT: 'ADD_TEMPLATE_TO_ELEMENT',
  DELETE_ROOT_ELEMENT: 'DELETE_ROOT_ELEMENT',
  DELETE_ELEMENT: 'DELETE_ELEMENT',
  UPDATE_ELEMENT: 'UPDATE_ELEMENT',
  CHANGE_ELEMENT: 'CHANGE_ELEMENT',
  DUPLICATE_ELEMENT: 'DUPLICATE_ELEMENT',
  SELECT_ELEMENT: 'SELECT_ELEMENT',
  OPEN_ELEMENTS_SELECTOR: 'OPEN_ELEMENTS_SELECTOR',
  CLOSE_ELEMENTS_SELECTORS: 'CLOSE_ELEMENTS_SELECTOR',
  SET_STATE_CHANGED: 'SET_STATE_CHANGED',
  CLEAR_STATE_CHANGED: 'CLEAR_STATE_CHANGED',
  SWITCH_ROOT_DOWN: 'SWITCH_ROOT_DOWN',
  SWITCH_DOWN: 'SWITCH_DOWN',
  SWITCH_ROOT_UP: 'SWITCH_ROOT_UP',
  SWITCH_UP: 'SWITCH_UP',
  ADD_COLUMN: 'CREATE_COLUMN',
  REMOVE_COLUMN: 'REMOVE_COLUMN',
  CLEAR_IS_ELEMENT_CHANGE: 'CLEAR_IS_ELEMENT_CHANGE',
}


// WEBPACK FOOTER //
// ./src/store/canvas/types.js